import { Localizer } from "infrastructure/localization/localizer";
import { SetTitleBar } from "../../core/layout/titleBar/titleBarApi";
import { KompetenceOverview } from "./details/kompetenceOverview";
import {RoutePaths} from "../../infrastructure/routes";
import {useRouteMatch} from "react-router-dom";
import { tryToBool } from "index";

export type KompetencerOverviewPageRouteParams = {
    id: string; //uddannelseslaegeId
    laegeKompetenceId?: string;
    activeTab?: string;
    getAllRegardlessOfMaalbeskrivelse?: string;
}

export function KompetencerOverviewPage() {
    const routeMatch = useRouteMatch<KompetencerOverviewPageRouteParams>();
    SetTitleBar(Localizer.global_kompetencer(),
        [{ text: Localizer.global_kompetencer(), url: RoutePaths.Kompetencer({uddannelseslaege: routeMatch.params.id}).url }]
    );
    return (
        <div className="card top-level-container">
            <KompetenceOverview 
                uddannelseslaegeId={routeMatch.params.id}
                laegeKompetenceId={routeMatch.params.laegeKompetenceId}
                getAllRegardlessOfMaalbeskrivelse={tryToBool(routeMatch.params.getAllRegardlessOfMaalbeskrivelse)}
            />
        </div>
    );
}
